const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const {
    Component
} = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @actions
const brokerTransferValuesActions = require('actions/brokerTransferValues');
const accountsActions = require('actions/getAccounts');
const brokerContractValues = require('actions/brokerContractValues');
const brokerStocksByTypeActions = require('actions/brokerStocksByType');

// @components
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardError = require('components/commons/wizardError/wizardError');
const BrokerTransferValuesStep1 = require('components/broker/brokerTransferValuesSteps/brokerTransferValuesStep1/brokerTransferValuesStep1');
const BrokerTransferValuesStep2 = require('components/broker/brokerTransferValuesSteps/brokerTransferValuesStep2/brokerTransferValuesStep2');
const BrokerTransferValuesStep3 = require('components/broker/brokerTransferValuesSteps/brokerTransferValuesStep3/brokerTransferValuesStep3');
const BrokerTransferValuesSuccessStep = require('components/broker/brokerTransferValuesSteps/brokerTransferValuesSuccessStep/brokerTransferValuesSuccessStep');
const BrokerTransferValuesSidebar = require('components/broker/brokerTransferValuesSidebar/brokerTransferValuesSidebar');

// @constants
const {
    BROKER_TRANSFER_VALUES_ERROR_MSG_VV8300,
    BROKER_TRANSFER_VALUES_ERROR_MSG_V60736,
    BROKER_TRANSFER_VALUES_ERROR_MSG_VV1197,
    BROKER_TRANSFER_VALUES_ERROR_MSG_VV0013,
    BROKER_TRANSFER_VALUES_ERROR_MSG_VV1196,
    BROKER_TRANSFER_VALUES_ERROR_MSG_VV0005,
    MYPROFILE_BROKER_URL
} = require('constants/index');

// @utils
const { scrollToTop } = require('commonsUtilities/scrollUtils');

class BrokerTransferValuesView extends Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentDidMount() {
        this.props.requestAccounts();
        scrollToTop();
        this.props.getStocksByType();
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    handleCancel() {
        this.props.history.push(`/myprofile/broker`);
    }

    handleFinish() {
        this.props.handleFinish();
    }

    buildWizard() {
        const {
            immStocksContracts,
            immTransferValues,
            resetContractErrors,
            setAccountFrom,
            setAccountTo,
            setAccountsFromOptions,
            setAccountsToOptions,
            validateStep,
            setVisibleStep,
            setWillCancel,
            getContractValues,
            immContractValues,
            setType
        } = this.props;

        const immSteps = immTransferValues.get('steps');
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };
        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immTransferValues.get('visibleStep')}
            >
                <WizardStep position="first" cancelButton={true} isLoading={immTransferValues.get('isFetching')}>
                    <BrokerTransferValuesStep1
                        immStocksContracts={immStocksContracts}
                        immTransferValues={immTransferValues}
                        resetContractErrors={resetContractErrors}
                        setAccountFrom={setAccountFrom}
                        setAccountTo={setAccountTo}
                        setAccountsFromOptions={setAccountsFromOptions}
                        setAccountsToOptions={setAccountsToOptions}
                    />
                </WizardStep>
                <WizardStep
                    position="middle"
                    cancelButton={true}
                >
                    <BrokerTransferValuesStep2
                        immStocksContracts={immStocksContracts}
                        immTransferValues={immTransferValues}
                        immContractValues={immContractValues}
                        getContractValues={getContractValues}
                        setType={setType}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    immFinalButton="broker-transferValuesFinish"
                    addLoadingBehaviour={true}
                >
                    <BrokerTransferValuesStep3
                        immStocksContracts={immStocksContracts}
                        immTransferValues={immTransferValues}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    buildSuccessful() {
        const { immTransferValues, immContractValues, immStocksContracts } = this.props;

        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8">
                <BrokerTransferValuesSuccessStep
                    immTransferValues={immTransferValues}
                    immContractValues={immContractValues}
                    immStocksContracts={immStocksContracts}
                />
            </div>
        )
    }

    buildErroneous() {
        const { immTransferValues } = this.props;
        const title = formatText('broker-transferValuesErrorTitle');
        const goBackButtonLabel = formatText('broker-transferValuesBack').toUpperCase();
        const linkToMovements = `/myprofile/broker`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToMovements
        };

        let errorMessage;

        switch (immTransferValues.getIn(['error', 'text'])) {
            case BROKER_TRANSFER_VALUES_ERROR_MSG_VV8300:
                errorMessage = <FormattedText value="broker-transferValuesErrorMessageVV8300" />;
                break;
            case BROKER_TRANSFER_VALUES_ERROR_MSG_V60736:
                errorMessage = <FormattedText value="broker-transferValuesErrorMessageV60736" />;
                break;
            case BROKER_TRANSFER_VALUES_ERROR_MSG_VV1197:
                errorMessage = <FormattedText value="broker-transferValuesErrorMessageVV1197" />;
                break;
            case BROKER_TRANSFER_VALUES_ERROR_MSG_VV0013:
                errorMessage = <FormattedText value="broker-transferValuesErrorMessageVV0013" />;
                break;
            case BROKER_TRANSFER_VALUES_ERROR_MSG_VV1196:
                errorMessage = <FormattedText value="broker-transferValuesErrorMessageVV1196" />;
                break;
            case BROKER_TRANSFER_VALUES_ERROR_MSG_VV0005:
                errorMessage = <FormattedText value="broker-transferValuesErrorMessageVV0005" />;
                break;
            default:
                errorMessage = <FormattedText value="broker-transferValuesErrorMessage" />;
                break;
        }

        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8">
                <WizardError errorMessage={title} mainButton={goBackButton}>
                    {errorMessage}
                </WizardError>
            </div>
        )
    }

    render() {
        const { immTransferValues, immStocksContracts, immContractValues, immMyInvestments } = this.props;
        const subtitleLeft = formatText('broker-transferValuesSubtitle');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerTransferBetweenMyAccounts')
            }
        ];

        let bodyContent;

        if (immTransferValues.get('submitSuccessful')) {
            bodyContent = this.buildSuccessful();
        } else if (immTransferValues.get('submitError')) {
            bodyContent = this.buildErroneous();
        } else {
            if(immMyInvestments.get('fetchSuccess')) {
                const wizard = this.buildWizard();
                bodyContent = (
                    <div id="printable-wizard">
                        <div className="col-xs-12 col-md-8">
                            <div className="row">
                                <div className="col-xs-12">
                                    {wizard}
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="row">
                                <div className="col-xs-12 grid-view--variable-cell-separation">
                                    <BrokerTransferValuesSidebar
                                        immTransferValues={immTransferValues}
                                        immContractValues={immContractValues}
                                        immStocksContracts={immStocksContracts}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                );
            } else {
                bodyContent = <LoadingSection />;
            }
        }

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="broker" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                subtitleLeft={subtitleLeft}
                                isSubtitleLeftCapital={false}
                                finalTitle={getFinalTitle('broker-transferValuesTitle')}>
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {bodyContent}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BrokerTransferValuesView.propTypes = {
    history: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    immTransferValues: PropTypes.object.isRequired,
    immContractValues: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    getStocksByType: PropTypes.func,
    resetContractErrors: PropTypes.func.isRequired,
    requestAccounts: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setType: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    setAccountTo: PropTypes.func.isRequired,
    setAccountFrom: PropTypes.func.isRequired,
    setAccountsFromOptions: PropTypes.func.isRequired,
    setAccountsToOptions: PropTypes.func.isRequired,
    getContractValues: PropTypes.func.isRequired
};

module.exports.constructor = BrokerTransferValuesView;
module.exports.BrokerTransferValuesView = connect(
    state => ({
        immStocksContracts: state.brokerStocksContract,
        immTransferValues: state.brokerTransferValues,
        immContractValues: state.brokerContractValues,
        immMyInvestments: state.brokerMyInvestments
    }), {
        requestAccounts: accountsActions.requestAccounts,
        validateStep: brokerTransferValuesActions.validateStep,
        setType: brokerTransferValuesActions.setType,
        setVisibleStep: brokerTransferValuesActions.setVisibleStep,
        setWillCancel: brokerTransferValuesActions.setWillCancel,
        handleFinish: brokerTransferValuesActions.doTransferValues,
        clearRequest: brokerTransferValuesActions.reset,
        resetContractErrors: brokerTransferValuesActions.resetContractErrors,
        setAccountFrom: brokerTransferValuesActions.setAccountFrom,
        setAccountTo: brokerTransferValuesActions.setAccountTo,
        setAccountsFromOptions: brokerTransferValuesActions.setAccountsFromOptions,
        setAccountsToOptions: brokerTransferValuesActions.setAccountsToOptions,
        getContractValues: brokerContractValues.getContractValues,
        getStocksByType: brokerStocksByTypeActions.getStocksByType,
    })(withRouter(BrokerTransferValuesView));
